type FilterItem = { id: string | number; name: string };
type FilterPills = Record<string, FilterItem[]>;

export const parseFiltersByLabels = (filters: Record<string, any>, filterPills: FilterPills): Record<string, any> => {
  return Object.entries(filters).reduce(
    (acc, [key, value]) => {
      const items = filterPills[key] || [];

      const getLabel = (id: string | number) => items.find((item) => item.id === id)?.name;

      if (Array.isArray(value)) {
        acc[key] = value.map((item) => getLabel(item.id));
      } else if (value?.id !== undefined) {
        acc[key] = getLabel(value.id);
      } else {
        acc[key] = value;
      }

      return acc;
    },
    {} as Record<string, any>,
  );
};
